import VideoPlayer from '../tools/videoplayer'

export default class Video {
  constructor (el, conf = {}) {
    this.el = el
    
  }

  init () {
    const video = new VideoPlayer(this.el)
  }
}

